import { useMutation, useQueryClient } from 'react-query-v5';
import { msalInstance, useAuthStore } from '@sib/auth';
import { updateUserId } from '@spendbrain/common/utils';

export const useLogout = () => {
  const { setAccount } = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      localStorage.clear();
      queryClient.clear();
      sessionStorage.clear();
      await msalInstance.logoutRedirect({
        onRedirectNavigate: () => {
          return false;
        },
      });
      setAccount(null);

      updateUserId();

      window.location.reload();
    },
  });
};
